// THEME LAYOUT JS

// If toggle button to show/hide sidebar is clicked, save that setting to  backend
$(document).on("click", ".js-sidebar-toggle", async function(event) {
  const toggleButton = event.target.closest(".js-sidebar-toggle");
  if (!toggleButton) return;

  let toggleFlag = 'true';
  
  toggleFlag = toggleButton.classList.contains('hide');
  toggleButton.classList.toggle('hide');

  // Wait for Rails.ajax to complete using a Promise
  await new Promise((resolve, reject) => {
    Rails.ajax({
      type: "PATCH",
      url: "/user_settings/toggle_display_complete_menu.js",
      data: `toggle_flag=${toggleFlag}`,
      success: resolve,
      error: reject
    });
  });

  // Only reload after response is received
  // IF ONE OF CANVAS PAGES or TYPING PAGE, RELOAD PAGE AS CANVAS NEEDS TO RELOAD ON THIS SCREEN CHANGE
  if (document.querySelector(".js-canvas-container") || document.querySelector('#js-typing-edit')) {
    location.reload();
  }
});

